export default __webpack_public_path__ + "static/media/LogoDTec.01ebb58b.png";